export default __webpack_public_path__ + "static/media/sign.c019dc57.png";